module.exports = __webpack_public_path__ + "img/logo2.83a58d3a.png";